/**
 * @Author: tom
 * @Date:   2017-11-20T00:03:29+01:00
 * @Last modified by:   tom
 * @Last modified time: 2018-02-06T11:27:30+01:00
 */

import Vue from 'vue'
import Router from 'vue-router'
// dynamic import; only load when needed for a route
const Home = () => import('@/components/Home')
const Aboutus = () => import('@/components/Aboutus')
// const Blog = () => import('@/components/Blog')
const Services = () => import('@/components/Services')
const CaseDetails = () => import('@/components/CaseDetails')
// const Career = () => import('@/components/Career')
// const GoCampaign = () => import('@/components/GoCampaign')
const Technology = () => import('@/components/Technology')
const NotFound = () => import('@/components/NotFound')
const Upgrade = () => import('@/components/Upgrade')

Vue.use(Router)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
      // specify offset of the element, all anchors on navigation bar
      // if (to.hash === '#anchor2') {
      position.offset = { y: 50 }

      if (document.querySelector(to.hash)) {
        // in case we need a delay before scrolling to hash:
        // return new Promise((resolve, reject) => {
        //   setTimeout(() => {
        //     resolve(position)
        //   }, 2000)
        // })
        return position
      }
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false
    }
  }
}

export default new Router({
  mode: 'history',
  // To allow anchors:
  scrollBehavior,
  routes: [
    {
      path: '/',
      alias: '/index.html',
      name: 'Home',
      component: Home
    },
    {
      path: '/aboutus',
      name: 'Aboutus',
      component: Aboutus
    },
    // { path: '/blog',
    //   name: 'Blog',
    //   component: Blog
    // },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/technology',
      name: 'Technology',
      component: Technology
    },
    // { path: '/career',
    //   name: 'Career',
    //   component: Career
    // },
    // { path: '/go/:id',
    //   name: 'QuickScan',
    //   component: GoCampaign
    // },
    {
      path: '/refcase/:id',
      name: 'CaseDetails',
      component: CaseDetails
    },
    /* global VERSION */
    {
      path: '/upgrade',
      alias: '/upgrade_' + VERSION.replace(/\./g, '_'),
      name: 'Upgrade',
      component: Upgrade
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})
